import React from "react";
import { useTabTitle } from "./hooks/useTabTitle";
import { ExlyInput } from "common/form";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";

export const TabTitle = () => {
  const { tabTitle, handleChange, handleBlur } = useTabTitle();
  const isDesktop = useIsDesktop();

  return (
    <div className={!isDesktop ? "tw-w-full" : "tw-w-[43%]"}>
      <ExlyInput
        value={tabTitle}
        onChange={(val) => handleChange({ target: { value: val } })}
        onBlur={handleBlur}
        placeholder="Enter Tab Title"
        fullWidth
        inputClassName="tw-bg-white"
      />
    </div>
  );
};
